import { forwardRef } from 'react';
import { KText } from '../../text';

// forwardRef so callers can measure the tag itself — with `isTruncated` it
// clips its own text, so a wrapper around it never overflows.
export const KTag = forwardRef<HTMLDivElement, any>(
  ({ value = 'All', isTable = false, ...props }, ref) => {
    return (
      <KText
        ref={ref}
        as="span"
        display="inline-flex"
        alignItems="center"
        textAlign="start"
        border="1px solid"
        borderColor="transparent"
        bgColor="secondary-50"
        borderRadius="sm"
        p="0.125em 0.5em"
        fontWeight={550}
        _groupHover={
          isTable ? { bg: 'base-white', borderColor: 'border-color' } : {}
        }
        {...props}
      >
        {value}
      </KText>
    );
  }
);

KTag.displayName = 'KTag';
